// src/components/dropdown-menu.ts
var DropdownMenu = class extends HTMLElement {
  constructor() {
    super();
    this.content = null;
    this.trigger = null;
    this.trigger = this.querySelector("[data-dropdown-trigger]");
    this.content = this.querySelector("[data-dropdown-content]");
  }
  connectedCallback() {
    var _a;
    (_a = this.trigger) == null ? void 0 : _a.addEventListener("click", () => this.toggleContent());
  }
  toggleContent() {
    this.content.classList.toggle("show");
    this.trigger.classList.toggle("show");
  }
};
customElements.define("dropdown-menu", DropdownMenu);
